export default __webpack_public_path__ + "static/media/21700plain.a80080e8.png";